// Reference data (payment methods, countries, currencies). All idempotent
// reads — cached aggressively at the hook layer (5+ min stale time).
import { apiClient, endpoints, unwrap } from '@core/api';
import { useStoreContextStore } from '@core/store/storeContextStore';

/** @returns {Promise<import('@core/types').PaymentMethod[]>} */
export async function listPaymentMethods() {
  const channelId = useStoreContextStore.getState().channelId;
  const raw = await apiClient.get(endpoints.account.paymentMethods, {
    query: { account_platform_id: channelId || undefined },
  });
  const { data } = unwrap(raw);
  const list = Array.isArray(data) ? data : [];
  return list.map((m) => ({
    id: m.payment_method_id ?? m.id,
    name: m.name ?? '',
    code: m.code ?? undefined,
    isActive: m.is_active ?? true,
  }));
}

export async function listCountries() {
  const raw = await apiClient.get(endpoints.reference.countries);
  const { data } = unwrap(raw);
  return Array.isArray(data) ? data : [];
}

export async function listCurrencies() {
  const raw = await apiClient.get(endpoints.reference.currencies);
  const { data } = unwrap(raw);
  return Array.isArray(data) ? data : [];
}
